interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
  articleData?: {
    headline: string;
    description: string;
    image: string;
    datePublished: string;
    dateModified: string;
    authorName: string;
    url: string;
  };
  faqData?: Array<{ question: string; answer: string }>;
}

export default function SchemaOrg({ type, data, articleData, faqData }: SchemaOrgProps) {
  const getSchema = () => {
    const baseOrg = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '国产一区二区精选内容导航平台',
      url: 'https://www.guochanyiqu.com',
      description: '汇聚海量优质国产内容资源，按分区精准分类，一区二区清晰划分，帮助用户快速找到所需内容。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-9999',
        contactType: 'customer service',
        email: 'contact@guochanyiqu.com',
        areaServed: 'CN',
        availableLanguage: 'zh-CN',
      },
    };

    switch (type) {
      case 'Organization':
        return baseOrg;

      case 'WebSite':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '国产一区二区精选内容导航平台',
          url: 'https://www.guochanyiqu.com',
          description: '汇聚海量优质国产内容资源，按分区精准分类，一区二区清晰划分，帮助用户快速找到所需内容。',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://www.guochanyiqu.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
          inLanguage: 'zh-CN',
        };

      case 'WebPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: data?.name || '国产一区二区精选内容导航平台',
          description: data?.description || '汇聚海量优质国产内容资源，按分区精准分类。',
          url: data?.url || 'https://www.guochanyiqu.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '国产一区二区精选内容导航平台',
            url: 'https://www.guochanyiqu.com',
          },
          inLanguage: 'zh-CN',
        };

      case 'Article':
        if (!articleData) return null;
        return {
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: articleData.headline,
          description: articleData.description,
          image: articleData.image,
          datePublished: articleData.datePublished,
          dateModified: articleData.dateModified,
          author: {
            '@type': 'Organization',
            name: articleData.authorName,
          },
          publisher: {
            '@type': 'Organization',
            name: '国产一区二区精选内容导航平台',
          },
          url: articleData.url,
          inLanguage: 'zh-CN',
        };

      case 'FAQPage':
        if (!faqData) return null;
        return {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqData.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        };

      default:
        return null;
    }
  };

  const schema = getSchema();
  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}